import { render, staticRenderFns } from "./RecentNew.vue?vue&type=template&id=9fa1e2b2&scoped=true&"
import script from "./RecentNew.vue?vue&type=script&lang=js&"
export * from "./RecentNew.vue?vue&type=script&lang=js&"
import style0 from "./RecentNew.vue?vue&type=style&index=0&id=9fa1e2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa1e2b2",
  null
  
)

export default component.exports